export class ImageDettaglioItem{
    constructor(){
        this.imgAltText,
        this.imgTitle,
        this.imgFileName,
        this.imgSrcRelativePath;
    }
}